import React, { useState, useEffect } from "react";
import { useParams, useNavigate  } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Col, Row, FormSelect , Button, Table, Form, InputGroup, FormControl, Card } from "react-bootstrap";
import moment from 'moment';
import SweetAlert2 from 'react-sweetalert2';
import apiService from '../../Auth/apiService';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import { useAuth } from "../../Auth/AuthContext";
import SeccionPageHeader from "./../Utils/SeccionPageHeader";
import CargandoSpinner from "./../Utils/CargandoSpinner";
import { FaCalendar } from "react-icons/fa";
import { ConsultarPersonaDocumento } from "../../Auth/ConsultasApi";

registerLocale('es', es);
setDefaultLocale('es');
// CustomInput moved outside of Persona for best practices and prop validation
const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input value={value} readOnly className='widthCalendar' tabIndex={-1} style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }} />
        <FaCalendar />
    </button>
));

export default function CrearPersona(){    
    const { idFamilia } = useParams();
    const { idPersona } = useParams();
    const navigate = useNavigate();
    const { token, rol, sedeActual, user } = useAuth();
    const usrRolid = rol;
    const [redirectId, setRedirectId] = useState(null);
    const [pendingPersona, setPendingPersona] = useState(null);
    const [cargando, setCargando] = useState(false);
    const [paises, setPaises] = useState([]);
    const [sexo, setSexo] = useState([]);
    const [tipoDocumentos, setTipoDocumentos] = useState([]);
    const [parentescos, setParentescos] = useState([]);
    const [motivosEgreso, setMotivosEgreso] = useState([]);
    const [sedeAlbergues, setSedeAlbergues] = useState([]);
    const [swalProps, setSwalProps] = useState({});
    const {register, handleSubmit, control, setValue, reset, watch, formState: { errors }} = useForm();
    
    function cancelarPersona() {
        reset();
        navigate(`/albergues/formularioalbergue/${idFamilia}`);
    }
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const saveIngreso = async (data) => {
        setCargando(true);
        data.usrId = user
        data.registroAtencion = true; // crea atencion en caracterizacion
        const url = '/albergue/guardarformulariopersonaalbergue';
        await apiService.post(url, data, token)
            .then(response => {
                if (response.status === 200) {
                    setRedirectId(idFamilia); // <-- Guardar el id para redirigir
                    setSwalProps({
                        show: true,
                        title: 'Guardar Formulario',
                        text: 'Guardado con éxito',
                        icon: 'success',
                        confirmButtonText: 'Aceptar'
                    });
                    resetForm(response.data.personaAlbergue);
                } else {
                    setSwalProps({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo guardar la persona.'
                    });
                }
            })
            .catch(error => {
                console.error('Error al guardar la persona:', error);
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error al guardar la persona.'
                });
            })
            .finally(() => {
                setCargando(false);
            });
    }
    const resetForm = (data) => {
        setValue('perfechanac', moment().set({ hour: 12, minute: 0, second: 0 }).toISOString());
        
        reset({
            usrId: user,
            id: data.id || '',
            fud: data.fud || '',
            declaraid: data.declaraid || idFamilia,
            tipodocumento: data.tipodocumento || '',
            documento: data.documento || '',
            primernombre: data.primernombre || '',
            segundonombre: data.segundonombre || '',
            primerapellido: data.primerapellido || '',
            segundoapellido: data.segundoapellido || '',
            parentesco: data.parentesco || '',
            sede: data.sede || '',
            fechaingreso: data.fechaingreso ?  moment(data.fechaingreso).toDate() : moment().toDate(),
            horaIngreso: data.fechaingreso
                ? moment.utc(data.fechaingreso).format('HH:mm')
                : moment().format('HH:mm'),
            personaActiva: data.fechasalida ? false : true,
            fechasalida: data.fechasalida ? moment(data.fechasalida).toDate() : null,
            horaSalida: data.fechasalida
                ? moment.utc(data.fechasalida).format('HH:mm')
                : null,
            perSexo: data.perSexo || '',
            perPaisorigen: data.perPaisorigen || '',
            perFechanac: moment(data.perfechanac, 'YYYY-MM-DD', true).isValid() 
                ? moment.utc(data.perfechanac).set({ hour: 12, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm:ss')
                : moment().set({ hour: 12, minute: 0, second: 0 }).toISOString(),
            motivoegresoid: data.motivoegresoid || '',
                
        });
    }
    useEffect(() => {
        if (tipoDocumentos.length > 0 && pendingPersona) {
            resetForm(pendingPersona);
            setPendingPersona(null);
        }
    }, [tipoDocumentos, pendingPersona]);
    function crearFormularioRegistroPersonaAlbegue(idFamilia, idPersona) {
        setCargando(true);
        const url = '/albergue/crearformulariopersonaalbergue';
        const obj = { sede: sedeActual, usrRolid: usrRolid, idFamilia: idFamilia, idPersona: idPersona};
        apiService.post(url, obj, token)
            .then(response => {
                if (response.status === 200) {
                    setPaises(response.data.paises);
                    setSexo(response.data.sexos);
                    setParentescos(response.data.parentescos);
                    setMotivosEgreso(response.data.motivosEgreso);
                    setSedeAlbergues(response.data.sedesAlbergue);
                    setTipoDocumentos(response.data.tipoDocumentos);
                    setPendingPersona(response.data.personaAlbergue); 

                } else {
                    Mensaje('Error', 'No se pudo cargar el formulario.');
                }
            })
            .catch(error => {
                console.error('Error al cargar el formulario:', error);
                Mensaje('Error', 'Ocurrió un error al cargar el formulario.');
            })
            .finally(() => {
                setCargando(false);
            });
    }
    useEffect(() => {
        if (idFamilia && idPersona) {
            crearFormularioRegistroPersonaAlbegue(idFamilia, idPersona);
        } else {
            reset();
        }
    }, [idFamilia]);
    async function ConsultarDocumento(identificacion){
        await ConsultarPersonaDocumento({obj: {per_idpersona: identificacion}, token: token})
        .then((response) => {            
            const fechanacimiento = moment(response.data.personas[0].fechanacimiento, 'YYYY-MM-DD', true).isValid() 
                ? moment.utc(response.data.personas[0].fechanacimiento).set({ hour: 12, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm:ss')
                : moment().set({ hour: 12, minute: 0, second: 0 }).toISOString()

            setValue('tipodocumento', response.data.personas[0].perTipoid);
            setValue('primernombre', response.data.personas[0].perNombre1);
            setValue('segundonombre', response.data.personas[0].perNombre2);
            setValue('primerapellido', response.data.personas[0].perApellido1);
            setValue('segundoapellido', response.data.personas[0].perApellido2);
            setValue('perPaisorigen', response.data.personas[0].perPaisorigen || '');
            setValue('parentesco', response.data.personas[0].perIdParentesco || '');
            setValue('perFechanac', fechanacimiento);
            setValue('perSexo', response.data.personas[0].perSexo || '');
        })
        .catch((error) => { 
            console.error('Error al consultar documento:', error);
        });
        
        
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Formulario crear persona albergue"
                idCabezaFamilia="1"
                url={`/albergues/formularioalbergue/${idFamilia}`}
                nombreurl="Familia albergue"
                nombreform="Formulario crear persona"/>
            <CargandoSpinner Cargando={cargando} />
            <section className="content">
                <div className="container-fluid">
                    <form className="form-horizontal" onSubmit={handleSubmit(saveIngreso)}>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h3">Formulario crear persona</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <input hidden {...register('usrId')}/>
                                <input hidden {...register('registroAtencion')}/>
                                <Row>
                                    <h4>Ingreso id: {watch('id')}</h4>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <b>Id Familia:</b> {watch('declaraid')} - <b>FUD:</b> {watch('fud')}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={3}>
                                        <div className="form-group" >
                                            <label htmlFor="tipodocumento">Tipo de identificaci&oacute;n</label>
                                            <select id="tipodocumento" className='form-control' 
                                                {...register('tipodocumento', { required: true })}
                                                >
                                                <option value="">Seleccionar</option>
                                                {tipoDocumentos.map(opt => (
                                                    <option key={opt.id} value={opt.id}>{opt.tipTipoidentificacion}-{opt.tipDescripcion}</option>
                                                ))}
                                            </select>
                                            {errors.tipodocumento && <p style={{color: 'red'}}>Seleccionar tipo identificaci&oacute;n</p>}
                                        </div>
                                    </Col>
                                    <Col sm={3}>
                                        <label htmlFor="documento">Documento</label>
                                        <input id="documento" className="form-control" 
                                            {...register('documento', { required: true })}
                                            placeholder="documento"
                                            name="documento"
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // Remove non-alphanumeric characters
                                                setValue('documento', value); // Update the value in the form
                                            }}
                                            onBlur={(e) => {
                                                ConsultarDocumento(e.target.value);
                                            }}/>
                                        {errors.documento && <p style={{color: 'red'}}>Digite el documento</p>}   
                                    </Col>
                                    <Col sm={3}>
                                        <div className="form-group" >
                                            <label htmlFor="perPaisorigen">Pais origen</label>
                                            <select id="perPaisorigen" className='form-control' {...register('perPaisorigen', { required: true })}>
                                                <option value="">Seleccionar</option>
                                                {paises.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.iso} - {option.pais}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perPaisorigen && <p style={{color: 'red'}}>Seleccione pais origen</p>}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={3}>
                                        <label htmlFor="primernombre">Primer nombre</label>
                                        <input id="primernombre" className="form-control" 
                                            {...register('primernombre', { required: true })}
                                            placeholder="primer nombre"
                                            name="primernombre"
                                            onChange={(e) => {
                                                const value = e.target.value.replaceAll(/[^A-Za-z0-9 ]/g, '').toUpperCase(); // Remove non-alphanumeric characters
                                                setValue('primernombre', value); // Update the value in the form
                                            }}/>
                                        {errors.primernombre && <p style={{color: 'red'}}>Digite primer nombre</p>}
                                    </Col>
                                    <Col sm={3}>
                                        <label htmlFor="segundonombre">Segundo nombre</label>
                                        <input id="segundonombre" className="form-control" 
                                            {...register('segundonombre')}
                                            placeholder="segundo nombre"
                                            name="segundonombre"
                                            onChange={(e) => {
                                                const value = e.target.value.replaceAll(/[^A-Za-z0-9 ]/g, '').toUpperCase(); // Remove non-alphanumeric characters
                                                setValue('segundonombre', value); // Update the value in the form
                                            }}/>
                                        {errors.segundonombre && <p style={{color: 'red'}}>Digite segundo nombre</p>}   
                                    </Col>
                                    <Col sm={3}>
                                        <label htmlFor="primerapellido">Primer apellido</label>
                                        <input id="primerapellido" className="form-control" 
                                            {...register('primerapellido', { required: true })}
                                            placeholder="primer apellido"
                                            name="primerapellido"
                                            onChange={(e) => {
                                                const value = e.target.value.replaceAll(/[^A-Za-z0-9 ]/g, '').toUpperCase(); // Remove non-alphanumeric characters
                                                setValue('primerapellido', value); // Update the value in the form
                                            }}/>
                                        {errors.primerapellido && <p style={{color: 'red'}}>Digite primer apellido</p>}
                                    </Col>
                                    <Col sm={3}>
                                        <label htmlFor="segundoapellido">Segundo apellido</label>
                                        <input id="segundoapellido" className="form-control" 
                                            {...register('segundoapellido')}
                                            placeholder="segundo apellido"
                                            name="segundoapellido"
                                            onChange={(e) => {
                                                const value = e.target.value.replaceAll(/[^A-Za-z0-9 ]/g, '').toUpperCase(); // Remove non-alphanumeric characters
                                                setValue('segundoapellido', value); // Update the value in the form
                                            }}/>
                                        {errors.segundoapellido && <p style={{color: 'red'}}>Digite segundo apellido</p>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={3}>
                                        <div className="form-group" >
                                            <label htmlFor="parentesco">Parentesco</label>
                                            <select id="parentesco" className='form-control' 
                                                {...register('parentesco', { required: true })}
                                                >
                                                <option value="">Seleccionar</option>
                                                    {parentescos.map(opt => (
                                                        <option key={opt.id} value={opt.id}>
                                                            {opt.par_parentesco}
                                                        </option>
                                                    ))}
                                            </select>
                                            {errors.parentesco && <p style={{color: 'red'}}>Seleccionar parentesco</p>}
                                        </div>
                                    </Col>
                                    <Col sm={3}>
                                        <div className="form-group" >
                                            <label htmlFor="sede">Sede</label>
                                            <select id="sede" className='form-control' 
                                                {...register('sede', { required: true })}
                                                >
                                                <option value="">Seleccionar</option>
                                                    {sedeAlbergues.map(opt => (
                                                        <option key={opt.id} value={opt.id}>
                                                            {opt.alb_nombre}
                                                        </option>
                                                    ))}
                                            </select>
                                            {errors.sede && <p style={{color: 'red'}}>Seleccionar sede</p>}
                                        </div>
                                    </Col>
                                    <Col sm={2}>
                                        <div className="form-group">
                                            <label htmlFor="perFechanac">Fecha Nacimiento</label>
                                            <Controller
                                                control={control}
                                                name="perFechanac"
                                                rules={{ required: "Seleccione fecha nacimiento" }}
                                                render={({ field }) => (
                                                    <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                        <DatePicker
                                                        placeholderText="fecha"
                                                        onChange={(date) => {field.onChange(date);}}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        selected={field.value instanceof Date ? field.value : (field.value ? new Date(field.value) : null)}
                                                        customInput={<CustomInput />}
                                                        locale="es"
                                                        dateFormat="yyyy-MM-dd"
                                                        maxDate={new Date()}
                                                        />
                                                    </div>
                                                )}
                                            />
                                            {errors.perFechanac && <p style={{color: 'red'}}>Seleccione fecha nacimiento</p>}
                                        </div>
                                    </Col>
                                    <Col sm={3}>
                                        <div className="form-group" >
                                            <label htmlFor="perSexo">Sexo</label>
                                            <select id="perSexo" className='form-control' {...register('perSexo', { required: true })}>
                                                <option value="">Seleccionar</option>
                                                {sexo.map((option) => (
                                                <option key={option.sex_nombre} value={option.sex_nombre}>
                                                    {option.sex_nombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perSexo && <p style={{color: 'red'}}>Seleccione sexo</p>}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={2}>
                                        <div className="form-group">
                                            <label htmlFor="fechaingreso">Fecha ingreso</label>
                                            <Controller
                                                control={control}
                                                name="fechaingreso"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                        <DatePicker
                                                            placeholderText="fecha ingreso"
                                                            onChange={(date) => field.onChange(date)}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value instanceof Date ? field.value : (field.value ? new Date(field.value) : null)}                                                                customInput={<CustomInput />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            maxDate={new Date()}
                                                        />
                                                    </div>
                                                )}
                                            />
                                            {errors.fechaingreso && <p style={{color: 'red'}}>Digite fecha ingreso</p>}
                                        </div>
                                    </Col>
                                    <Col sm={2}>
                                        <div className="form-group">
                                            <label htmlFor="horaIngreso">Hora ingreso</label>
                                            <Controller
                                                control={control}
                                                name="horaIngreso"
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <FormControl
                                                        id="horaIngreso"
                                                        type="time"
                                                        value={field.value || ''}
                                                        onChange={field.onChange}
                                                    />
                                                )}
                                            />
                                            {errors.horaIngreso && <p style={{color: 'red'}}>Digite hora ingreso</p>}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={3}>
                                        <div className="form-group">
                                            <div className="custom-control custom-switch">
                                            <input type="checkbox" 
                                                {...register('personaActiva')}
                                                className="custom-control-input" id="SwitchPermanencia"/>
                                            <label className="custom-control-label" htmlFor="SwitchPermanencia">Permanencia en el albergue</label>
                                            </div>
                                        </div>
                                    </Col>
                                    <>
                                        <Col sm={2}>
                                            <div className="form-group">
                                                <label htmlFor="fechasalida">Fecha salida</label>
                                                <Controller
                                                    control={control}
                                                    name="fechasalida"
                                                    rules={{
                                                        validate: value => watch('personaActiva') || value ? true : 'Digite fecha salida'
                                                    }}
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                            <DatePicker
                                                                placeholderText="fecha salida"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value instanceof Date ? field.value : (field.value ? new Date(field.value) : null)}                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                maxDate={new Date()}
                                                                disabled={watch('personaActiva')}
                                                            />
                                                        </div>
                                                    )}
                                                />
                                                {errors.fechasalida && <p style={{color: 'red'}}>Digite fecha salida</p>}
                                            </div>
                                        </Col>
                                        <Col sm={2}>
                                            <div className="form-group">
                                                <label htmlFor="horaSalida">Hora salida</label>
                                                <Controller
                                                    control={control}
                                                    name="horaSalida"
                                                    rules={{
                                                        validate: value => watch('personaActiva') || value ? true : 'Digite hora salida'
                                                    }}
                                                    render={({ field }) => (
                                                        <FormControl
                                                            id="horaSalida"
                                                            type="time"
                                                            value={field.value || ''}
                                                            onChange={field.onChange}
                                                            disabled={watch('personaActiva')}
                                                        />
                                                    )}
                                                />
                                                {errors.horaSalida && <p style={{color: 'red'}}>Digite hora salida</p>}
                                            </div>
                                        </Col>
                                        <Col sm={3}>
                                            <div className="form-group" >
                                                <label htmlFor="motivoegresoid">Motivo salida</label>
                                                <select 
                                                    id="motivoegresoid" 
                                                    className='form-control' 
                                                    {...register('motivoegresoid', { 
                                                        validate: value => watch('personaActiva') || value ? true : 'Seleccionar motivo de egreso'
                                                     })}
                                                    disabled={watch('personaActiva')}
                                                    >
                                                    <option value="">Seleccionar</option>
                                                        {motivosEgreso.map(opt => (
                                                            <option key={opt.id} value={opt.id}>
                                                                {opt.mot_motivo}
                                                            </option>
                                                        ))}
                                                </select>
                                                {errors.motivoegresoid && <p style={{color: 'red'}}>Seleccionar motivo de egreso</p>}
                                            </div>
                                        </Col>
                                    </>
                                </Row> 
                            </Card.Body>
                            <Card.Footer>
                                <Row>
                                    <Col>
                                        <Button type="submit">Guardar</Button>
                                    </Col>
                                    <Col>
                                        <Button onClick={cancelarPersona}>Volver a familia</Button>
                                    </Col>
                                </Row>
                            </Card.Footer>
                        </Card>
                    </form>
                </div>
                <SweetAlert2
                    {...swalProps}
                    didClose={() => {
                        setSwalProps({});
                        if (redirectId) {
                            navigate(`/albergues/formularioalbergue/${redirectId}`);
                            setRedirectId(null);
                        }
                    }}
                />
            </section>
        </div>
    );
}